import { View, Text } from 'react-native';
import React from 'react';

const PendingInsurance = () => {
  return (
    <View>
      <Text className="text-center text-sm font-medium color-gray-400">
        Iniciamos o processo de emissão de sua apólice e agora você precisa
        completar duas etapas para ativar o seu seguro:
      </Text>

      <Text className="text-center text-sm color-gray-400 mt-6">
        • Realizar a vistoria veicular.
      </Text>
      <Text className="text-center text-sm color-gray-400">
        • Realizar o pagamento da 1ª parcela do seguro.
      </Text>

      <Text className="text-center text-sm font-medium color-gray-400 mt-6">
        Para auxílio com a vistoria ou outras informações, contate:
      </Text>

      <Text className="mt-6 text-center text-sm font-medium color-gray-400">
        Assegurou
        <Text className="font-normal"> (Departamento de Endossos)</Text>
      </Text>

      <Text className="text-center text-sm font-medium color-gray-400">
        São Paulo ligue: <Text className="font-normal">(11) 2110-7727 </Text>-
        Ramal <Text className="font-normal">7725</Text>
      </Text>

      <Text className="text-center text-sm font-medium color-gray-400">
        Outros Estados ligue: <Text className="font-normal">0800 591 3676</Text>
      </Text>

      <Text className="text-center text-sm font-medium color-gray-400">
        Email:{' '}
        <Text className="font-normal underline">endossos@assegurou.com.br</Text>
      </Text>

      <Text className="text-center text-sm color-gray-400">
        Horário: segunda a sexta-feira, das 08h às 18h
      </Text>

      <Text className="text-center text-sm color-gray-400 mt-6">
        Assim que a sua apólice for aceita, você irá receber via e-mail a sua
        proposta para assinatura eletrônica.
      </Text>

      <Text className="text-xs text-center color-gray-400 my-6">
        * Sujeito à aprovação
      </Text>
    </View>
  );
};

export default PendingInsurance;
